var storefrontApp = angular.module('storefrontApp');


storefrontApp.controller('mainController', ['$scope', '$location', '$window', 'customerService', 'storefrontApp.mainContext',
    function($scope, $location, $window, customerService, mainContext) {

        //Base store url populated in layout and can be used for construction url inside controller
        $scope.baseUrl = {};

        mainContext.countries = [
            { "name": "United States", "code2": "US", "code3": "USA", "regionType": "State" },
            { "name": "Canada", "code2": "CA", "code3": "CAN", "regionType": "Province" },
            { "name": "Mexico", "code2": "MX", "code3": "MEX", "regionType": "State" }
        ];

        mainContext.usaStates = [{ "name": "Alabama", "code": "AL" }, { "name": "Alaska", "code": "AK" }, { "name": "Arizona", "code": "AZ" }, { "name": "Arkansas", "code": "AR" }, { "name": "California", "code": "CA" }, { "name": "Colorado", "code": "CO" }, { "name": "Connecticut", "code": "CT" }, { "name": "Delaware", "code": "DE" }, { "name": "Florida", "code": "FL" }, { "name": "Georgia", "code": "GA" }, { "name": "Hawaii", "code": "HI" }, { "name": "Idaho", "code": "ID" }, { "name": "Illinois", "code": "IL" }, { "name": "Indiana", "code": "IN" }, { "name": "Iowa", "code": "IA" }, { "name": "Kansas", "code": "KS" }, { "name": "Kentucky", "code": "KY" }, { "name": "Louisiana", "code": "LA" }, { "name": "Maine", "code": "ME" }, { "name": "Maryland", "code": "MD" }, { "name": "Massachusetts", "code": "MA" }, { "name": "Michigan", "code": "MI" }, { "name": "Minnesota", "code": "MN" }, { "name": "Mississippi", "code": "MS" }, { "name": "Missouri", "code": "MO" }, { "name": "Montana", "code": "MT" }, { "name": "Nebraska", "code": "NE" }, { "name": "Nevada", "code": "NV" }, { "name": "New Hampshire", "code": "NH" }, { "name": "New Jersey", "code": "NJ" }, { "name": "New Mexico", "code": "NM" }, { "name": "New York", "code": "NY" }, { "name": "North Carolina", "code": "NC" }, { "name": "North Dakota", "code": "ND" }, { "name": "Ohio", "code": "OH" }, { "name": "Oklahoma", "code": "OK" }, { "name": "Oregon", "code": "OR" }, { "name": "Pennsylvania", "code": "PA" }, { "name": "Rhode Island", "code": "RI" }, { "name": "South Carolina", "code": "SC" }, { "name": "South Dakota", "code": "SD" }, { "name": "Tennessee", "code": "TN" }, { "name": "Texas", "code": "TX" }, { "name": "Utah", "code": "UT" }, { "name": "Vermont", "code": "VT" }, { "name": "Virginia", "code": "VA" }, { "name": "Washington", "code": "WA" }, { "name": "Washington DC", "code": "DC" }, { "name": "West Virginia", "code": "WV" }, { "name": "Wisconsin", "code": "WI" }, { "name": "Wyoming", "code": "WY" }];
        mainContext.mexStates = [{ "name": "Aguascalientes", "code": "AGS" }, { "name": "Baja California", "code": "BC" }, { "name": "Baja California Sur", "code": "BCS" }, { "name": "Chihuahua", "code": "CHIH" }, { "name": "Colima", "code": "COL" }, { "name": "Campeche", "code": "CAMP" }, { "name": "Coahuila", "code": "COAH" }, { "name": "Chiapas", "code": "CHIS" }, { "name": "Distrito Federal", "code": "DF" }, { "name": "Durango", "code": "DGO" }, { "name": "Guerrero", "code": "GRO" }, { "name": "Guanajuato", "code": "GTO" }, { "name": "Hidalgo", "code": "HGO" }, { "name": "Jalisco", "code": "JAL" }, { "name": "Michoacán", "code": "MICH" }, { "name": "Morelos", "code": "MOR" }, { "name": "México", "code": "MEX" }, { "name": "Nayarit", "code": "NAY" }, { "name": "Nuevo León", "code": "NL" }, { "name": "Oaxaca", "code": "OAx" }, { "name": "Puebla", "code": "PUE" }, { "name": "Quintana Roo", "code": "Q ROO" }, { "name": "Querétaro", "code": "QRO" }, { "name": "Sinaloa", "code": "SIN" }, { "name": "San Luis Potosí", "code": "SLP" }, { "name": "Sonora", "code": "SON" }, { "name": "Tabasco", "code": "TAB" }, { "name": "Tlaxcala", "code": "TLAX" }, { "name": "Tamaulipas", "code": "TAMPS" }, { "name": "Veracruz", "code": "VER" }, { "name": "Yucatán", "code": "YUC" }, { "name": "Zacatecas", "code": "ZAC" }];
        mainContext.canRegions = [{ "name": "Alberta", "code": "AB" }, { "name": "British Columbia", "code": "BC" }, { "name": "Manitoba", "code": "MB" }, { "name": "New Brunswick", "code": "NB" }, { "name": "Newfoundland", "code": "NL" }, { "name": "Northwest Territories", "code": "NT" }, { "name": "Nova Scotia", "code": "NS" }, { "name": "Nunavut", "code": "NU" }, { "name": "Ontario", "code": "ON" }, { "name": "Prince Edward Island", "code": "PE" }, { "name": "Quebec", "code": "QC" }, { "name": "Saskatchewan", "code": "SK" }, { "name": "Yukon", "code": "YT" }];

        mainContext.getCountryRegions = function (country) {
            switch (country.code3) {
                case 'USA':
                    return mainContext.usaStates;
                case 'CAN':
                    return mainContext.canRegions;
                case 'MEX':
                    return mainContext.mexStates;
                default:
                    return [];
            }
        };

        $scope.$watch(function() {
            $scope.currentPath = $location.$$path.replace('/', '');
        });

        $scope.$on('storefrontError', function(event, data) {
            $scope.storefrontNotification = data;
            $scope.storefrontNotification.detailsVisible = false;
        });

        $scope.toggleNotificationDetails = function() {
            $scope.storefrontNotification.detailsVisible = !$scope.storefrontNotification.detailsVisible;
        }

        $scope.closeNotification = function() {
            $scope.storefrontNotification = null;
        }

        //For outside app redirect (To reload the page after changing the URL, use the lower-level API)
        $scope.outerRedirect = function(absUrl) {
            $window.location.href = absUrl;
        };

        //change in the current URL or change the current URL in the browser (for app route)
        $scope.innerRedirect = function(path) {
            $location.path(path);
            $scope.currentPath = $location.$$path.replace('/', '');
        };

        //$scope.stringifyAddress = function(address) {
        //    var stringifiedAddress = address.firstName + ' ' + address.lastName + ', ';
        //    stringifiedAddress += address.organization ? address.organization + ', ' : '';
        //    stringifiedAddress += address.countryName + ', ';
        //    stringifiedAddress += address.regionName ? address.regionName + ', ' : '';
        //    stringifiedAddress += address.city + ' ';
        //    stringifiedAddress += address.line1 + ', ';
        //    stringifiedAddress += address.line2 ? address.line2 : '';
        //    stringifiedAddress += address.postalCode;
        //    return stringifiedAddress;
        //}

        $scope.getObjectSize = function(obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) {
                    size++;
                }
            }
            return size;
        }

        mainContext.getCustomer = $scope.getCustomer = function() {
            return customerService.getCurrentCustomer().then(function (response) {
                var addressId = 1;
                _.each(response.data.addresses, function(address) {
                    address.id = addressId;
                    addressId++;
                });
                response.data.isContact = response.data.memberType === 'Contact';
                mainContext.customer = $scope.customer = response.data;
            });
        };

        $scope.getCustomer();
    }])

    .factory('storefrontApp.mainContext', function() {
        return {};
    });
